import { Form, Select } from 'antd';
import Refund from 'components/ArticleOffer/offer/ArticleStatus/Refund';
import { TextArea } from 'components/Form';

const showRefund = ['eu_control', 'pub_control'];

const options = [
  {
    value: 'owner_committee',
    label: 'Sorumlu İlim Heyeti',
  },
  {
    value: 'eu_control',
    label: 'Ansiklopedi Birimi',
  },
  {
    value: 'pub_control',
    label: 'Yayın Müdürlüğü',
  },
];

const EncylopeiaManagementUnitRevert = ({ isEncyclopediaUnitControl = false, hideDescription = false, step, status, committee }) => {
  const form = Form.useFormInstance();
  const selectedCommittee = Form.useWatch('to', form);
  return (
    <>
      {/* Ansiklopedi birimi kontrolu degilse iade etmek istediğiniz birimi seçin */}
      {!isEncyclopediaUnitControl && (
        <Form.Item
          className="gx-mb-5"
          rules={[
            {
              required: true,
              message: 'Bu Alan Zorunludur',
            },
          ]}
          name="to"
        >
          <Select
            placeholder="İade etmek istediğiniz birimi seçin"
            options={options}
          />
        </Form.Item>
      )}
      {showRefund.includes(selectedCommittee) && (
        <Refund
          toCommittee={selectedCommittee}
          step={step}
          status={status}
          committee={committee}
        />
      )}
      {!hideDescription && (
        <Form.Item name="description">
          <TextArea
            placeholder="Notunuz varsa girebilirsiniz"
            rows={7}
            showCount
          />
        </Form.Item>
      )}
    </>
  );
};

export default EncylopeiaManagementUnitRevert;
